import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      name: yup.string().nullable(),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'AT_LEAST_ONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      // eslint-disable-next-line arrow-body-style
      value => Object.values(value).some(val => val && val !== ''),
    );

export default validationSchema;
